import { v4 as uuid } from 'uuid';
import { ServicesSectionConfig } from './types';
import { Service } from 'model/Service';

const getStandardRate = (service: Service): number => service.pricing?.fixedPrice?.[0]?.price || 0;

export const ratesConfig: ServicesSectionConfig = {
    description: 'Choose the applicable services for this rate.',
    columns: [
        { key: 'service', label: 'Service Name' },
        { key: 'standardRate', label: 'Standard Rate' },
        { key: 'newRate', label: 'New Rate' }
    ],
    gridTemplateColumns: '2fr 1fr 1fr',
    mobileRateLabel: 'Standard Rate',
    showNewRateColumn: true,
    createServiceItem: (service: Service, standardRate: number) => ({
        id: uuid(),
        serviceId: service.id!,
        serviceName: service.name,
        standardRate,
        newRate: standardRate
    })
};

export const rateRulesConfig: ServicesSectionConfig = {
    description: 'Choose the applicable services for this rate rule.',
    columns: [
        { key: 'service', label: 'Boarding Service' },
        { key: 'standardRate', label: 'Default Rate' }
    ],
    gridTemplateColumns: '7fr 5fr',
    mobileRateLabel: 'Default Rate',
    showNewRateColumn: false,
    createServiceItem: (service: Service, standardRate: number) => ({
        id: uuid(),
        serviceId: service.id!,
        serviceName: service.name,
        standardRate
    })
};

export { getStandardRate };
